export default __webpack_public_path__ + "static/media/tortoise.86aebb69.svg";